<forge-badge *ngIf="showBadge" [attr.theme]="theme">{{value}}</forge-badge>
